import axios from 'axios';
import { getContext } from '@fiverr-private/fiverr_context';
import pathfinder from '@fiverr-private/pathfinder';
import { logger } from '@fiverr-private/obs';
import { baseErrorEnrichment } from '../../errorEnrichment';
import { EMPTY_COLLECTIONS } from './constants';

export const updateCollection = async (url, params = {}) => {
    try {
        const { data } = await axios.put(url, params);

        return getUpdatableCollectionProperties(data.collection);
    } catch (error) {
        logger.error(error, { ...baseErrorEnrichment(), description: 'Failed to update an existing collection' });

        throw error;
    }
};

export const deleteCollection = async (url) => {
    try {
        const { data } = await axios.delete(url);

        return getUpdatableCollectionProperties(data.collection);
    } catch (error) {
        logger.error(error, { ...baseErrorEnrichment(), description: 'Failed to delete an existing collection' });

        throw error;
    }
};

/**
 * Fetch all collections for current user.
 */
export const fetchAllCollections = async () => {
    const { userId } = getContext();
    const isLoggedIn = !!userId;

    if (!isLoggedIn) {
        return EMPTY_COLLECTIONS;
    }

    try {
        const url = pathfinder('collection_list');

        const { data } = await axios.get(url);

        return data.collections;
    } catch (error) {
        logger.error(error, { ...baseErrorEnrichment(), description: 'Failed to fetch all user collections' });

        throw error;
    }
};

export const shareWithTeam = async (url, params = {}) => {
    try {
        const { data } = await axios.post(url, params);

        return getUpdatableCollectionProperties(data.collection);
    } catch (error) {
        logger.error(error, { ...baseErrorEnrichment(), description: 'Failed to share a collection' });

        throw error;
    }
};

export const getUpdatableCollectionProperties = (collection = {}) => ({
    id: collection.id,
    name: collection.name,
    description: collection.description,
    slug: collection.slug,
    ownerId: collection.ownerId,
    ownerType: collection.ownerType,
    privacyType: collection.privacyType,
});
